import React, { Component } from 'react'
import './downloadcard.scss'
import Button from '../Button'

class DownloadCard extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--downloadcard', this.props.classes].join(' ')
		return (
			<div className={classes}>
				<div className="card-icon">
					<span className={this.props.cardIcon}></span>
				</div>
				<div className="card-content">
					<div className="title-element">
						{this.props.classes === 'no-description' && (
							<span className={[this.props.cardIcon, 'mobile-icon'].join(' ')}></span>
						)}
						<p className="card-title">{this.props.title}</p>
					</div>
					{this.props.subtitle && <p className="card-subtitle">{this.props.subtitle}</p>}
					<Button classes="fill medium" showIcon="true" icon="icon-icon-download" onClick={this.props.onClick}>
						{this.props.btnText}
					</Button>
				</div>
			</div>
		)
	}
}

export default DownloadCard
